export default {
  rollover: {
    title: 'เทิร์นโอเวอร์',
    detailsTitle: 'รายละเอียดเทิร์นโอเวอร์',
    all: 'ทั้งหมด',
    allStats: 'สถานะทั้งหมด',
    select: 'เลือก',
    rolloverType: 'ประเภทเทิร์นโอเวอร์',
    amount: 'จำนวนเงิน',
    source: 'แหล่งที่มา',
    wallet: 'กระเป๋าเงิน',
    current: 'ปัจจุบัน',
    wagered: 'เดิมพันแล้ว',
    required: 'ที่ต้องการ',
    progress: 'ความคืบหน้า',
    loading: 'กำลังโหลด...',
    noData: 'ไม่มีข้อมูล',
    noMoreData: 'ไม่มีข้อมูลเพิ่มเติม',
    state: 'สถานะ',
    type: 'ประเภท',
    createdOn: 'สร้างเมื่อ',
    wageringRequirement: 'เงื่อนไขการเดิมพัน',
    currency: 'สกุลเงิน',
    wagerRequired: 'ยอดเดิมพันที่ต้องการ',
    wagerCompleted: 'ยอดเดิมพันที่ทำได้',
    cash: 'เงินสด',
    bonus: 'โบนัส',
  },
};
